import { z } from 'zod'

import asset from './asset'
import assetLink from './asset-link'
import call from './call'
import callItem from './call-item'
import callReport from './call-report'
import callReportAttachment from './call-report-attachment'
import contract from './contract'
import contractRenovation from './contract-renovation'
import equipment from './equipment'
import equipmentVista from './equipment-vista'
import equipmentVistaItem from './equipment-vista-item'
import order from './order'
import orderReport from './order-report'
import person from './person'
import personAddress from './person-address'
import personContact from './person-contact'
import product from './product'
import storage from './storage'
import StorageRule from './StorageRule'
import StorageTransaction from './StorageTransaction'
import user from './user'

export default {
  asset,
  assetLink,
  call,
  callItem,
  callReport,
  callReportAttachment,
  contract,
  contractRenovation,
  equipment,
  equipmentVista,
  equipmentVistaItem,
  order,
  orderReport,
  person,
  personAddress,
  personContact,
  product,
  storage,
  StorageRule,
  StorageTransaction,
  user,
}

export type User = z.infer<typeof user>
